import apiClient, { safeJson } from '@/api/client';
import {
    CoachWorkRoutineResponse,
    GetCoachWorkRoutineParams,
    PatchCoachWorkRoutineBody,
} from './types';

/**
 * @method get
 * @brief 강사 근무시간 조회
 */
export const getCoachWorkRoutines = async ({ centerId, year, month }: GetCoachWorkRoutineParams) => {
    const res = await apiClient.get(`v1/coachWorkRoutines/center/${centerId}`, {
        searchParams: { year, month },
    });

    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as CoachWorkRoutineResponse | null,
    };
};

/**
 * @method patch
 * @brief 강사 근무시간 설정 (upsert)
 */
export const patchCoachWorkRoutines = async ({
    centerId,
    body,
}: {
    centerId: string;
    body: PatchCoachWorkRoutineBody;
}) => {
    const res = await apiClient.patch(`v1/coachWorkRoutines/center/${centerId}`, {
        json: body,
    });

    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as CoachWorkRoutineResponse | null,
    };
};
